import { useState, useEffect, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AlloyButton, useExpander } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import styles from './FacetListExpander.module.scss';
import cx from 'classnames';

const FacetListExpander = ({
  facetValues,
  isSubspecification,
  renderFacets,
  renderSubSpecifications
}) => {
  const [t] = useTranslation();

  const [minHeight, setMinHeight] = useState(null);
  const [isFacetListOpened, setIsFacetListOpened] = useState(false);
  const { isExpanded, ref, toggle } = useExpander({
    minHeight
  });
  useLayoutEffect(() => {
    setMinHeight(ref.current?.scrollHeight);
  }, [ref]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isExpanded) {
        setIsFacetListOpened(false);
      }
    }, 250);
    return () => {
      clearTimeout(timer);
    };
  }, [isExpanded]);

  const handleToggle = () => {
    if (!isFacetListOpened) {
      setIsFacetListOpened(true);
    }
    toggle();
  };

  const slicedFacets = facetValues?.slice(
    0,
    !isFacetListOpened ? 8 : facetValues.length
  );

  return (
    <>
      <div
        className={cx(styles['facet-list_expander'], 'p-3 transition-expand')}
        ref={ref}
      >
        {isSubspecification
          ? renderSubSpecifications(slicedFacets)
          : renderFacets(slicedFacets)}
      </div>
      <AlloyButton className="px-2" buttonType="ghost" onClick={handleToggle}>
        {isExpanded ? t('VIEW_LESS') : t('VIEW_MORE_PRODUCTS')}
      </AlloyButton>
    </>
  );
};

FacetListExpander.propTypes = {
  facetValues: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      facet: PropTypes.string,
      label: PropTypes.string
    })
  ),
  renderFacets: PropTypes.func,
  renderSubSpecifications: PropTypes.func,
  isSubspecification: PropTypes.bool
};

export default FacetListExpander;
